import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() {
  }

  getNumberWithLeadingZero(num: number | null): string {
    if (num == null) {
      return "";
    }

    const strNum = num.toString();
    if (strNum.length > 1) return strNum;
    return `0${strNum}`;
  }

  getOrderFormattedNumber(num: number | null): string {
    if (num == null) {
      return "";
    }

    let strNum = num.toString();
    let finalString = "";
    let firstPartLength = strNum.length % 3;
    if (firstPartLength == 0) firstPartLength = 3;
    finalString = strNum.slice(0, firstPartLength)
    strNum = strNum.slice(firstPartLength);
    let partsNumber = Math.floor(strNum.length / 3);
    for (let i = 0; i < partsNumber; i++) {
      finalString = `${finalString}.${strNum.slice(0, 3)}`;
      strNum = strNum.slice(0, 3);
    }

    return finalString;
  }

  getNormalizeGermanString(str: string, toLowerCase: boolean=false): string {
    if(str == null) return "";

    const umlautMap: Record<string, string> = {
      'Ä': 'ae', 'Ö': 'oe', 'Ü': 'ue',
      'ä': 'ae', 'ö': 'oe', 'ü': 'ue',
      'ß': 'ss'
    };

    let replacedStr = str.replace(/[ÄÖÜäöüß]/g, (match) => umlautMap[match]);

    if (toLowerCase){
      return replacedStr.toLowerCase();
    }
    else{
      return replacedStr.toLowerCase();
    }
  }
}
